import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=238d0890"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"
import style0 from "./forgot-password.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports